import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { EProcessStatus } from 'core/dto';
import { Observable, map, tap } from 'rxjs';
import { designerPaths } from '../../designer.paths';
import { JwtRefreshService } from '../../global-services/jwt-refresh.service';
import { JwtService } from '../../global-services/jwt.service';

@Injectable({
  providedIn: 'root'
})
export class ReverseAuthGuard implements CanActivate {

  readonly jwtSubject = this._jwtService.jwtSubject;
  readonly jwtExpiredSubject = this._jwtService.jwtExpiredSubject;
  readonly refreshTokenExistsSubject = this._jwtService.refreshTokenExistsSubject;

  constructor(
    private readonly _jwtService: JwtService,
    private readonly _jwtRefreshService: JwtRefreshService,
    private readonly _router: Router
  ) {

  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {



    return this._jwtRefreshService.loggedInObs.pipe(
      map(x => !x),
      tap((canActivate) => {
        if (!canActivate) {
          this._router.navigate([designerPaths.processOverview, EProcessStatus.WaitingForMe])
        }
      })
    )
  }

}
